import { render, staticRenderFns } from "./OffersContainer.vue?vue&type=template&id=990f33f8&scoped=true&"
import script from "./OffersContainer.vue?vue&type=script&lang=js&"
export * from "./OffersContainer.vue?vue&type=script&lang=js&"
import style0 from "./OffersContainer.vue?vue&type=style&index=0&id=990f33f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990f33f8",
  null
  
)

export default component.exports